import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-radio-button',
    styleUrl: 'radio-button.component.scss',
    templateUrl: 'radio-button.component.html',
})
export class RadioButtonComponent {
    public readonly checked = input<boolean>(false);
    public readonly disabled = input<boolean>(false);
    public readonly radioClick = output<MouseEvent>();

    protected onRadioClick(event: MouseEvent): void {
        event.stopPropagation();

        if (this.disabled()) {
            return;
        }

        this.radioClick.emit(event);
    }
}
